<template>
  <div class="form-wrapper">
    <div class="form-fields-wrapper">
      <base-form-field v-model="personalInfo.nationalIdNumber" :schema="schema.nationalIdNumber" />
    </div>
    <div class="form-buttons-wrapper"><next-button @click="submit" text="Submit" /></div>
  </div>
</template>
<script setup lang="ts">
import { $api } from "@/services/api";
import { reactive, ref } from "vue";
import { FieldSchema, FormSchema } from "@/models/form";
import BaseFormField from "@/components/shared/BaseFormField.vue";
import NextButton from "@/components/shared/NextButton.vue";
import useValidation from "@/use/validation";
import { Applicant } from "@/models/application";
import { Stipulation } from "@/models/opal";
import { StipulationInputRequest } from "@/models/api";

interface Props {
  applicant: Applicant;
  stip: Stipulation;
}

const props = withDefaults(defineProps<Props>(), {});

const emit = defineEmits<{
  (e: "success", updatedStip: Stipulation): void;
}>();

const { validateForm } = useValidation();

let personalInfo = ref({} as any);

const submittingData = ref<boolean>(false);

const schema = reactive<FormSchema>({
  nationalIdNumber: {
    type: "ssn",
    label: "SSN",
    placeholder: "###-##-####",
    required: true,
  } as FieldSchema,
} as FormSchema);

async function submit() {
  submittingData.value = true;
  const valid = validateForm(schema, personalInfo.value);
  if (valid) {
    const request = {
      applicationStipulationId: props.stip?.id,
      applicationId: props?.stip?.applicationId,
      ssnInput: {
        ssn: personalInfo.value?.nationalIdNumber?.split("-")?.join(""),
      },
    } as StipulationInputRequest;

    const response = await $api.applications.addStipInput(props?.stip?.applicationId, request);

    if (response?.id && response?.id > 0) {
      // updates stip status to pending
      let updatedSSNVerificationStip = props.stip;
      updatedSSNVerificationStip.stipulationStatusId = response.stipulationStatusId;
      updatedSSNVerificationStip.stipulationStatusName = response.stipulationStatusName;
      
			emit("success", updatedSSNVerificationStip);

      submittingData.value = false;
    } else {
      submittingData.value = false;
    }
  } else {
    submittingData.value = false;
  }
}
</script>
<style scoped>
.form-wrapper .form-fields-wrapper {
  display: flex;
  flex-direction: column;
  gap: 1em;
}
.form-wrapper .form-buttons-wrapper {
  margin-top: 1rem;
}
</style>
